import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from 'redux/store';
import { closeEditTranslationComponent } from 'redux/actions/edit-translations';
import { translationUpdateSections } from 'redux/actions/users';
import { EditableCourseElements, TranslationInfo } from 'redux/schemas/models/edit-translations';
import { getCurrentUser } from 'redux/selectors/users';

import EditableSimpleInput from './base/editable-simple-input';

type EditableProps = {
  editInfo: TranslationInfo,
  onSaveRef: (fn: () => void) => void,
  setSavingDisabled: (boolean) => void,
};

const EditableCourseSections = ({
  editInfo,
  onSaveRef,
  setSavingDisabled,
}: EditableProps) => {
  const [value, setValue] = useState(editInfo.content as string);
  const currentUser = useSelector(getCurrentUser);
  const dispatch = useAppDispatch();

  const save = useCallback(() => {
    const language = currentUser.translationPreferenceLanguage;
    const { id } = editInfo;
    const name = 'title';
    let lessonType;

    switch (editInfo.type) {
      case EditableCourseElements.LESSON:
        lessonType = 'LecturePage';
        break;
      case EditableCourseElements.SUBSECTION:
        lessonType = 'LectureSubsection';
        break;
      case EditableCourseElements.SECTION:
      default:
        lessonType = 'LectureSection';
    }

    const payload = {
      type: lessonType,
      id,
      language,
      attributes: [
        {
          name,
          text: value,
        },
      ],
    };
    dispatch(translationUpdateSections(payload)).then(() => {
      dispatch(closeEditTranslationComponent());
    });
  }, [currentUser.translationPreferenceLanguage, dispatch, editInfo, value]);

  useEffect(() => {
    onSaveRef(() => save);
  }, [onSaveRef, save]);

  useEffect(() => {
    if (editInfo.content !== value) {
      setSavingDisabled(false);
    }
    return (() => {
      setSavingDisabled(true);
    });
  }, [value]);

  return (
    <EditableSimpleInput value={value} setValue={setValue} />
  );
};

export default EditableCourseSections;
